<template>
    <v-container >
        <div>
            <v-row justify="space-between" no-gutters>
                <v-col cols="12" sm="6" justify="center">
                    <p class="header-title"> Thống kê nguyên vật liệu </p>
                </v-col>

                <v-col cols="12" sm="6" justify="center">
                    <v-row justify="start">
                        <v-col cols="12" sm="5">
                            <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" persistent width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="computedDateFormatted" v-bind:label="$t('common.date_range')" readonly v-on="on" outlined dense background-color="#ffffff">
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="dates" scrollable range locale="vi" no-title>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(dates)"> {{ $t('common.ok') }} </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete v-model="selectNumberFilter" :items="numberFilters" item-text="name" v-bind:label="$t('statistic.number')" outlined return-object dense background-color="#ffffff"></v-autocomplete>
                        </v-col>
                        
                        <v-col cols="12" sm="3">
                            <v-btn dark color="primary" @click="statisticData" large> Thống kê </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <v-container class="white" >
        <!-- <span> Chọn khoảng thời gian: </span>  -->
            <v-row no-gutters>
                <v-col cols="12" sm="3" class="pr-5">
                    <v-autocomplete v-model="selectMaterial" :items="materials" item-text="name" v-bind:label="$t('statistic.material')" outlined return-object dense></v-autocomplete>
                </v-col>
                
                <v-col cols="12" sm="3">
                    <v-autocomplete v-model="selectTopFilter" :items="topFilters" item-text="name" v-bind:label="$t('statistic.top_filter')" outlined return-object dense></v-autocomplete>
                </v-col>
            </v-row>

            <GChart
                :settings="{packages: ['corechart']}"    
                :data="chartDatas"
                :options="chartOptions"
                :createChart="(el, google) => new google.visualization.BarChart(el)"
                @ready="onChartReady"
            />
        </v-container>
        <v-overlay :value="overlay" :z-index="0">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
t
<script>
import { GChart } from 'vue-google-charts'
import moment from 'moment';

export default {
    components: {
        GChart
    },

    data: () => ({
        overlay: false,
        chartsLib: null,

        dates: [],
        date: {},

        chartDatas: [
            ['Nguyên vật liệu', 'Đơn vị', { role: 'annotation' }]
        ],

        resultDatas: [],

        materials: [],
        selectMaterial: {},
        topFilters: [
            {name: 'Tất cả', value: -1},
            {name: 'Top 5', value: 5},
            {name: 'Top 10', value: 10},
            {name: 'Top 15', value: 15}
        ],
        selectTopFilter: {},
        numberFilters: [
            {name: 'Tất cả', value: -1},
            {name: '<= 100', value: 0},
            {name: '> 100', value: 1}
        ],
        selectNumberFilter: {},

        materialStyles: [],
        heightChart: 800,
        modal: false
    }),

    watch: {
        selectMaterial() {
            this.filterData();
        },
        selectTopFilter() {
            this.filterData();
        },
        selectNumberFilter() {
            this.filterData();
        }
    },

    computed: {
        chartOptions () {

            return {
                // title: 'Bảng thống kê nguyên vật liệu',
                bars: 'horizontal', // Required for Material Bar Charts.
                hAxis: { format: 'decimal', textStyle: {fontSize: 14}},
                vAxis: {textStyle: {fontSize: 14}},
                height: this.heightChart,
                colors: ['#363F7A'],
                annotations: { textStyle: {fontSize: 14}},
                animation : {
                    startup: true,
                    duration: 200,
                    easing: 'inAndOut'
                },
                chartArea: {top: 30, width:'80%'},
                legend: {position: 'top', textStyle: {fontSize: 14}}
            }
        },

        computedDateFormatted () {
            if (this.dates.length < 2) {
                return;
            }

            this.sortDate();
            return this.formatDate(this.date.start) + ' ~ ' + this.formatDate(this.date.end);
        },
    },

    created () {
    //   this.getMaterial();
        this.date.end = new Date();
        this.date.start = new Date(new Date().setDate(this.date.end.getDate() - 30));
      
        const startDate = moment(this.date.start).format("YYYY-MM-DD");
        const endDate = moment(this.date.end).format("YYYY-MM-DD");

        
        this.dates.push(startDate);
        this.dates.push(endDate);

        this.sortDate();

        this.getDataStatistic();
        this.selectTopFilter = this.topFilters[0];
        this.selectNumberFilter = this.numberFilters[0];
    },

    methods: {
        onChartReady (chart, google) {
            this.chartsLib = google
        },

        initialize () {
            
        },

        sortDate () {
            const startDate = new Date(this.dates[0]);
            const endDate = new Date(this.dates[1]);

            if (startDate.getTime() < endDate.getTime()) {
                this.date.start = startDate;
                this.date.end = endDate;
            } else {
                this.date.start = endDate;
                this.date.end = startDate;
            }       
        },

        formatDate (date) {
            if (!date) {
                return null;
            }
            return moment(date).format("DD/MM/YYYY");
        },

        statisticData() {
            this.getDataStatistic();
        },

        async getMaterial() {
            try {
                const response = await this.$http.get('/material');
                if (response.data && response.data.success) {
                    // this.materials = response.data.data;
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.materials = [optionAll].concat(response.data.data);
                
                    if (Array.isArray(this.materials) && this.materials.length > 0) {
                        this.selectMaterial = this.materials[0];
                    }
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        async getDataStatistic() {
            this.overlay = true;
            try {
                // https://backend.ledaihoan.com/api/statistic/material?numberQuery=-1&from=20/12/2019&to=21/12/2019
                const from = moment(String(this.date.start)).format("DD/MM/YYYY");
                const to = moment(String(this.date.end)).format("DD/MM/YYYY");

                const response = await this.$http.get('/api/statistic/material?numberQuery=' + this.selectNumberFilter.value + "&from=" + from + "&to=" + to);
                this.overlay = false;
                if (response.data && response.data.success) {
                    const dataArray = response.data.data;
                    // this.materials = dataArray.materials;
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.materials = [optionAll].concat(dataArray.materials);
                    if (Array.isArray(this.materials) && this.materials.length > 0) {
                        this.selectMaterial = this.materials[0];
                    }

                    this.materialStyles = dataArray.stats;
                    this.resultDatas = [];

                    if (Array.isArray(this.materialStyles) && this.materialStyles.length > 0) {
                        this.materialStyles.forEach(item => {
                            const materialStyleString = item.material.name + " - " + item.color_name;
                            const weight = item.totalWeight;
                            const qty = item.totalNumber;
                            const dataObject = {
                                nameDisplay: materialStyleString,
                                material: item.material,
                                weight: weight,
                                qty: qty
                            }

                            this.resultDatas.push(dataObject);
                        })
                        
                        this.filterData()
                        // this.generateDataForChart(this.resultDatas);
                    }
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        generateDataForChart(arrayData) {
            this.chartDatas = [];
            this.chartDatas.push(['Nguyên vật liệu', 'Đơn vị', { role: 'annotation'}]);
            
            if (Array.isArray(arrayData) && arrayData.length > 0) {
                arrayData.forEach(item => {
                     this.chartDatas.push([item.nameDisplay, item.weight, item.weight]);
                });
            }

            this.heightChart = this.chartDatas.length * 80;
        },

        filterData() {
            if (!this.resultDatas || this.resultDatas.length == 0) {
                return;
            }


            let dataArray = [].concat(this.resultDatas);
            console.log(dataArray);

            if (this.selectMaterial._id != -1) {
                console.log(this.selectMaterial._id);
                // this.jobs.find(item => item._id == job._id)
                dataArray = dataArray.filter(item => item.material._id == this.selectMaterial._id);
            }
            
            // if (this.selectNumberFilter.value == 0) {
            //     dataArray = dataArray.filter(item => item.qty <= 100);
            // } else if (this.selectNumberFilter.value == 1) {
            //     dataArray = dataArray.filter(item => item.qty > 100);
            // }

            if (this.selectTopFilter.value > 0) {
                dataArray = dataArray.slice(0, this.selectTopFilter.value);
            }

            //  console.log(this.resutlDatas);

            this.generateDataForChart(dataArray);
        }
    }
}
</script>

<style scoped>
.heightPicker {
    height: 200px;
    width: 200px;
}
</style>